module.exports = __webpack_public_path__ + "assets/images/stripe-cards.png?_1418d6059e1a";